import { render, staticRenderFns } from "./OfficialVideo.vue?vue&type=template&id=6aadbee1&"
import script from "./OfficialVideo.vue?vue&type=script&lang=js&"
export * from "./OfficialVideo.vue?vue&type=script&lang=js&"
import style0 from "./OfficialVideo.vue?vue&type=style&index=0&id=6aadbee1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports